
import { format, isAfter, parseISO } from "date-fns";

export const removeNullishFieldsParams = (params: Record<any, any> = {}) => {
  Object.entries(params).forEach(([key, value]) => {
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      delete params[key];
    }
  });

  return params;
};

export const formatNumberWithoutCurrency = (
  value: number,
  locale: string = 'en-US',
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 2
) => {
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits,
    maximumFractionDigits
  }).format(value);
}

export const getActiveQuarter = (date: Date = new Date()): { from: any; to: any } => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const quarter = Math.floor(month / 3) + 1;
  const startMonth = (quarter - 1) * 3;
  const endMonth = startMonth + 2;
  const from = format(new Date(year, startMonth, 1), "yyyy-MM-dd");
  const to = format(new Date(year, endMonth + 1, 0), "yyyy-MM-dd");
  return { from, to };
}

function buildFormData(
  formData: FormData,
  data: Record<any, any>,
  parentKey = ""
) {
  if (
    data &&
    typeof data === "object" &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      buildFormData(
        formData,
        data[key],
        parentKey ? `${parentKey}[${key}]` : key
      );
    });
  } else {
    let value: any = data;
    if (data && !(data instanceof String) && !(data instanceof Blob)) {
      value = data.toString();
    }
    formData.append(parentKey, value);
  }
}

export const createdFormData = (payload: Record<any, any>) => {
  const formdata = new FormData();

  buildFormData(formdata, payload);

  return formdata;
};

export const isFutureDateTime = (inputDateTime: string): boolean => {
  const now = new Date();
  const givenDateTime = parseISO(inputDateTime); // Parse the input to a Date object

  // Compare the given date-time with the current date-time
  return isAfter(givenDateTime, now);
};

export const normalizeUserIds = (items: any): number[] => {
  if (!items) return [];
  if (!Array.isArray(items)) {
    items = [items];
  }
  return items
    .map((item) => (item && typeof item === "object" ? item.id : item))
    .filter((id) => id !== null && id !== undefined && id !== "")
    .map((id) => Number(id))
    .filter((id) => !isNaN(id));
};


// WEBPACK FOOTER //
// ./src/app/shared/object_helpers.ts